<template>
  <aside id="slider" :class="['main-sidebar', $root.hideSideMenu?'':'']">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- Sidebar user panel -->
      <div class="user-panel1">
        <div class="image user-header" style="padding: 20px;">
          <img :src="logoPath" class="user-image center-block roundImage" alt="User Image">
        </div>
        <a href="#" @click="$root.goto('Account')">
          <div class="text-center" style="padding: 10px; font-size: 16px; color: #ffffff;">
            <p>{{ $root.userFullName }}</p>
            <p v-if="$root.userCompanyName">{{ $root.userCompanyName }}</p>
          </div>
        </a>
      </div>
      <div class="user-panel" style="display: none;">
        <div class="pull-left image">
          <img src="https://image.flaticon.com/icons/png/512/149/149071.png" class="user-image" alt="User Image">
        </div>
        <div class="pull-left info">
          <p>{{ $root.userFullName }}</p>
          <a v-if="$root.user.Connected" href="#"><i class="fa fa-circle" style="color:green;"></i> online</a>
          <a v-else href="#"><i class="fa fa-circle" style="color:red;"></i> offline</a>
        </div>
        <div class="pull-right" v-if="$root.device.isMobile">
          <i class="fa fa-sign-out text-red btn btn-flat" style="font-size: 20px;" @click="$root.logout"></i>
          <!--<a href="#" class="btn btn-default btn-flat" @click="$root.logout">Sign out</a>-->
        </div>
      </div>
      <!-- search form -->
      <form action="#" method="get" class="sidebar-form">
        <div class="input-group">
          <input type="text" name="q" class="form-control" placeholder="Search..." v-model="txtSearch" style="background-color: white;">
          <span class="input-group-btn">
            <div class="btn btn-flat" style="background-color: white;"><i class="fa fa-search"></i></div>
          </span>
        </div>
      </form>
      <ul data-widget="tree" class="sidebar-menu">
        <va-slide-item v-for="(item,index) in $root.slideTopItems"
                       @click.native="slideItemClick(item)"
                       :data="item"
                       :key="index"
                       :type="item.type"
                       :isHeader="item.isHeader"
                       :isLink="item.isLink"
                       :icon="item.icon"
                       :FullName="$root.shortText(item.FullName, 20)"
                       :title="item.FullName"
                       :badge="item.badge"
                       :items="item.items"
                       :router="item.router"
                       :link="item.link"
                       v-show="item.show">
        </va-slide-item>
        <!--<ul data-widget="tree" class="sidebar-menu">
        </ul>-->
        <li title="Download LAN Installer" v-if="$root.isDealer || $root.isDealerAssistance">
          <a @click="lanInstalledClicked()" target="_blank" :href="$root.installerLinks.LanInstaller" role="button">
            <i class="fa fa-download"></i>
            <span>Download LAN Installer</span>
          </a>
        </li>
        <li title="Download USB Installer" v-if="$root.isDealer || $root.isDealerAssistance">
          <a @click="usbInstalledClicked()" target="_blank" :href="$root.installerLinks.UsbInstaller" role="button">
            <i class="fa fa-download"></i>
            <span>Download USB Installer</span>
          </a>
        </li>
      </ul>
        <ul data-widget="tree" class="sidebar-menu">
          <va-slide-item v-for="(item,index) in filteredItems"
                         @click.native="slideItemClick(item)"
                         :data="item"
                         :key="index"
                         :type="item.type"
                         :isHeader="item.isHeader"
                         :isLink="item.isLink"
                         :icon="item.icon"
                         :FullName="$root.shortText(item.FullName, 20)"
                         :title="item.FullName"
                         :badge="item.badge"
                         :items="item.items"
                         :router="item.router"
                         :link="item.link"
                         v-show="item.show">
          </va-slide-item>
        </ul>
</section>
  <div style="height: 100px;">
  </div>
  <!-- /.sidebar -->
</aside>
</template>
<script>
  import { db } from './firebase'
  import VASlideItem from './components/VASlideItem'
  // import { CalculateDashboard } from './plugins/dashboard.js'
  export default {
    name: 'va-slider',
    components: { 'va-slide-item': VASlideItem },
    data () {
      return {
        clickes: 0,
        isLocal: false,
        slideItems: [],
        txtSearch: '',
        logoPath: 'https://image.flaticon.com/icons/png/512/149/149071.png'
      }
    },
    created () {
      if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
        // alert('It is a local server!')
        this.isLocal = true
      }
      this.$root.reloadSlideItems()
      // CalculateDashboard(this, db)
      // if (this.$root.isAdmin) {
      //  this.$root.loadAdminSlideItems()
      // } else {
      //  this.$root.loadSlideItems()
      // }
      if (this.$root.user.Logo) {
        this.logoPath = this.$root.user.Logo
      }
    },
    firebase: function () {
      var vm = this
      let itemsPath = ''
      if (vm.$root.isAdmin) {
        itemsPath = 'Dealers'
      } else {
        itemsPath = 'Dealers/' + vm.$root.user['.key']
      }
      let itemsRef = db.ref(itemsPath)
      return {
        items: itemsRef.orderByKey()
      }
    },
    computed: {
      hasData () {
        return this.filteredItems !== null && this.filteredItems !== undefined && this.filteredItems.length > 0
      },
      filteredItems () {
        const vm = this
        if (vm.txtSearch.length > 0) {
          if (vm.$root.slideItems) {
            vm.$root.slideItems.forEach(function (slideItem) {
              slideItem.show = (String(slideItem.FullName).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1)
              if (slideItem.items && !slideItem.show) {
                slideItem.items.forEach(function (item) {
                  item.show = (String(item.FullName).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1)
                  if (item.show) {
                    slideItem.show = true
                  }
                  if (item.subItems && !item.show) {
                    item.subItems.forEach(function (subItem) {
                      subItem.show = (String(subItem.FullName).trim().toLowerCase().indexOf(vm.txtSearch.trim().toLowerCase()) > -1)
                      if (subItem.show) {
                        item.show = true
                        slideItem.show = true
                      }
                    })
                  }
                })
              }
            })
          }
        } else {
          vm.setSlideItemsShow(true)
        }
        return vm.$root.slideItems
      }
    },
    methods: {
      lanInstalledClicked () {
        let vm = this
        let title = 'Lan Client Installer'
        let message = 'Lan Client Installer was downloaded.'
        vm.$root.setAlert(title, message)
      },
      usbInstalledClicked () {
        let vm = this
        let title = 'Usb Client Installer'
        let message = 'Usb Client Installer was downloaded.'
        vm.$root.setAlert(title, message)
      },
      setSlideItemsShow (isShow) {
        let vm = this
        if (vm.$root.slideItems) {
          vm.$root.slideItems.forEach(function (slideItem) {
            slideItem.show = isShow
            if (slideItem.items) {
              slideItem.items.forEach(function (item) {
                item.show = isShow
                if (item.subItems) {
                  item.subItems.forEach(function (subItem) {
                    subItem.show = isShow
                  })
                }
              })
            }
          })
        }
      },
      slideItemClick (item) {
        // console.log('slideItemClick ... item.type = ' + item.type)
        // console.log('slideItemClick ... item.FullName = ' + item.FullName)
        // console.log('slideItemClick ... item.key = ' + item.key)
        if (this.$root.isAdmin) {
          this.$root.filter.dealerKey = item.key
        }
        if (item.type === 'tree') {
          // console.log('slideItemClick ...' + item.type + ' ... ' + item.FullName)
          // this.$root.filter.customerKey = item.key
          // this.$root.filter.siteKey = 'All'
          // this.$root.goto('Printers')
        } else {
        }
      }
    }
  }
</script>
<style scoped>
  .main-sidebar {
    background-color: #222d32;
    height: 100vh;
    min-height: 100vh;
    overflow-y: auto;
  }
  .sidebar-collapse .main-sidebar {
    width: 0px !important;
  }
  .forceCollapse {
    width: 0px !important;
  }
  .user-panel > .image > img {
    padding-top: 10px;
    width: 100%;
    max-width: 60%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// Slider.vue?d627d4d2